import React from "react";
import { ResponsiveHeatMap } from "@nivo/heatmap";
import legend_h from "../assets/legend_heatmap_h.png";
import { Image } from "antd";

const ClassicHeatmap = (props) => {
  let commonProps = {};
  const MAX_VISIBLE_ROWS = 10;
  const ROW_HEIGHT = 90;

  const heatmapData = props.data.names.map((name, i) => ({
    id: `${i + 1}. ${name.slice(0, 10)}`,
    data: [
      { x: "River Flood", y: props.data.values[i]["River Flood"] },
      { x: "Typhoon", y: props.data.values[i]["Typhoon"] },
      { x: "Storm Surge", y: props.data.values[i]["Storm Surge"] },
      { x: "Wildfire", y: props.data.values[i]["Wild Fire"] },
      { x: "Landslide", y: props.data.values[i]["Landslide"] },
      { x: "Rainfall Flood", y: props.data.values[i]["Rainfall Flood"] },
      { x: "Extreme Cold", y: props.data.values[i]["Extreme Cold"] },
      { x: "Extreme Heat", y: props.data.values[i]["Extreme Heat"] },
      { x: "Drought", y: props.data.values[i]["Drought"] },
      { x: "Snowfall", y: props.data.values[i]["Snow Fall"] },
      { x: "Sea Level Rise", y: props.data.values[i]["Sea Level Rise"] },
      { x: "Average", y: props.data.values[i]["Average"] },
    ],
  }));

  const n = props.data.names.length;
  const totalRows = heatmapData.length;

  const variables = [
    "River Flood",
    "Typhoon",
    "Storm Surge",
    "Wildfire",
    "Landslide",
    "Rainfall Flood",
    "Extreme Cold",
    "Extreme Heat",
    "Drought",
    "Snowfall",
    "Sea Level Rise",
    "Average",
  ];

  const Ave_variabes = [
    "River Flood",
    "Typhoon",
    "Storm Surge",
    "Wild Fire",
    "Landslide",
    "Rainfall Flood",
    "Extreme Cold",
    "Extreme Heat",
    "Drought",
    "Snow Fall",
    "Sea Level Rise",
    "Average",
  ];

  const columnWidth = `${100 / variables.length}%`;

  return (
    <div style={{ width: "100%" }}>
      {/* 🔝 Sticky Legend */}
      <div
        style={{
          position: "sticky",
          top: 0,
          backgroundColor: "#fff",
          zIndex: 15,
          display: "flex",
          justifyContent: "center",
          padding: "10px 0",
          borderBottom: "1px solid #ccc",
        }}
      >
        <Image src={legend_h} height={60} preview={false} />
      </div>

      {/* 🔝 Sticky Top Header (Hazard Labels) */}
      <div
        style={{
          position: "sticky",
          top: 0,
          background: "#fafafa",
          zIndex: 10,
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "nowrap",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "110px",
              flexShrink: 0,
              backgroundColor: "white",
            }}
          ></div>
          {variables.map((key) => (
            <div
              key={key}
              style={{
                width: columnWidth,
                padding: "10px 0",
                borderBottom: "1px solid #ccc",
                textAlign: "center",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <strong>{key}</strong>
            </div>
          ))}
        </div>
      </div>

      {/* 🔄 Scrollable Heatmap */}
      <div
        style={{
          height:
            n === 1 ? 120 : Math.min(totalRows, MAX_VISIBLE_ROWS) * ROW_HEIGHT,
          overflowY: totalRows > MAX_VISIBLE_ROWS ? "auto" : "hidden",
          overflowX: "hidden",
          position: "relative",
        }}
      >
        {/* Inner wrapper ensures correct total height for scroll */}
        <div style={{ height: totalRows * ROW_HEIGHT, width: "100%" }}>
          <ResponsiveHeatMap
            {...commonProps}
            data={heatmapData}
            keys={props.variable}
            indexBy="id"
            margin={{ top: 0, right: 0, bottom: 0, left: 110 }}
            valueFormat=">-.2s"
            isInteractive={false}
            axisTop={null}
            axisBottom={null}
            colors={{
              type: "diverging",
              scheme: "yellow_orange_red",
              divergeAt: 0.5,
              minValue: 0,
              maxValue: 100,
            }}
            emptyColor="#555"
            legends={[]}
            theme={{
              labels: {
                text: {
                  fontSize: 20,
                  fontWeight: 800,
                },
              },
            }}
          />
        </div>
      </div>

      {/* 🔻 Sticky Bottom Footer (Averages) */}
      <div
        style={{
          position: "sticky",
          bottom: 0,
          background: "#fafafa",
          zIndex: 10,
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "nowrap",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "110px",
              flexShrink: 0,
              backgroundColor: "white",
            }}
          ></div>
          {props.data.heatmap_average &&
            Ave_variabes.map((key) => (
              <div
                key={key}
                style={{
                  width: columnWidth,
                  padding: "10px 0",
                  borderBottom: "1px solid #ccc",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <strong>Avg&nbsp;</strong>
                {props.data.heatmap_average[key] || "0"}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ClassicHeatmap;
